import styled from 'styled-components';

export const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const ContentContainer = styled.div`
  width: 100%;
`;

export const Main = styled.main`
  flex: 1;
  width: 100%;
`;

export const FooterWrapper = styled.div`
  z-index: 9;
  background: white;
`; 